import { Controller } from "@hotwired/stimulus"

// Handles cascading dropdowns on the media kit run form:
// Collection → Color Palette → Colorways
// Also provides select-all / deselect-all for colorways.

export default class extends Controller {
  static targets = ["collectionSelect", "paletteSelect", "paletteOptions", "colorwayGroup"]

  connect() {
    // Initialize on page load
    this.filterPalettes()
  }

  // Step 1: When collection changes, update palette dropdown
  filterPalettes() {
    const selectedCollectionId = this.collectionSelectTarget.value
    const paletteSelect = this.paletteSelectTarget
    
    // Clear current palette options
    paletteSelect.innerHTML = '<option value="">Select a collection first…</option>'
    
    if (!selectedCollectionId) {
      this.hideAllColorways()
      return
    }
    
    // Find the palette options for this collection
    const paletteOptionsDiv = this.paletteOptionsTargets.find(
      div => div.dataset.collectionId === selectedCollectionId
    )
    
    if (paletteOptionsDiv) {
      paletteSelect.innerHTML = '<option value="">Select a palette…</option>' + paletteOptionsDiv.innerHTML
    }
    
    // Hide all colorways until a palette is selected
    this.hideAllColorways()
  }

  // Step 2: When palette changes, show its colorways
  filterColorways() {
    const selectedPaletteId = this.paletteSelectTarget.value
    
    this.colorwayGroupTargets.forEach(group => {
      const match = selectedPaletteId && group.dataset.paletteId === selectedPaletteId
      group.classList.toggle("hidden", !match)

      // Uncheck colorways that are hidden so they don't sneak into the params
      if (!match) {
        group.querySelectorAll("input[type='checkbox']").forEach(cb => {
          cb.checked = false
        })
      } else {
        // Re-check all when a palette is selected (default: include all)
        group.querySelectorAll("input[type='checkbox']").forEach(cb => {
          cb.checked = true
        })
      }
    })
  }

  hideAllColorways() {
    this.colorwayGroupTargets.forEach(group => {
      group.classList.add("hidden")
      group.querySelectorAll("input[type='checkbox']").forEach(cb => {
        cb.checked = false
      })
    })
  }

  selectAll() {
    this._visibleCheckboxes().forEach(cb => { cb.checked = true })
  }

  selectNone() {
    this._visibleCheckboxes().forEach(cb => { cb.checked = false })
  }

  _visibleCheckboxes() {
    return this.colorwayGroupTargets
      .filter(g => !g.classList.contains("hidden"))
      .flatMap(g => [...g.querySelectorAll("input[type='checkbox']")])
  }
}
